module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("List of Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_vm._v("1. Grenadier of a Volunteer regiment, c.1805")]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_vm._v("2. ‘A Military Squabble about Dress’")]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_vm._v("3. St George’s Volunteers charging down Bond Street")]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_vm._v("4. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘")]), _vm._v("Push on, brave York volunteers’")]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_vm._v("5. The Battle of Châteauguay, 1813")]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_vm._v("6. Lieutenant Colonel Charles de Salaberry leads his volunteers and militiamen at Châteauguay")]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_vm._v("7. Lieutenant Colonel de Salaberry, victor of Châteauguay")]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_vm._v("8. The Victorian amateur soldier, Staffordshire Rifle Volunteers, c.1860")]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_vm._v("9. Officers of the 1st Aberdeenshire Rifles, 1881")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("10. Uniforms of the 1st Sutherland Volunteer Rifle Corps, 1860–1908")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("11. Bicycle-mounted Volunteers in South Africa, 1899")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("12. Officers of the 1st US Volunteer Cavalry, ‘Rough Riders’, at Long Island before embarkation for the invasion of Cuba, 1898")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("13. 1st US Volunteer Cavalry at Las Gausimas")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("14. Captain Parker’s Gatling guns on Cuba")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("15. 71st New York Volunteers in quarantine in the USA after the Cuban campaign")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("16. The Spanish Falangist leader, José Antonio Primo de Rivera, inspects his blue-shirted militia before the outbreak of the Spanish Civil War")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("17. Republican militia besieging the Alcázar")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("18. Heroic portrayal of Falangist militia in July 1936")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("19. Weapons inspection for Castroist MNR militiamen")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("20. MNR militia in action, probably during the Bay of Pigs invasion")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("21. Castroist troops advance behind T34/85 tanks during the Bay of Pigs fighting")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("22. MNR militia in action")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_vm._v("23. MNR militiamen with Czech-made Soviet anti-aircraft artillery")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da50da7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Illustrations.vue
// module id = 72
// module chunks = 0